import {
  Table,
  TableContainer,
  Tbody,
  Td,
  Th,
  Thead,
  Tr,
} from "@chakra-ui/react";
import React from "react";

type GridTableProps = {
  data: any[];
};

const GridTable = ({ data }: GridTableProps) => {
  const formatPrice = (price: string | undefined): string => {
    if (!price) return "";
    const numericPrice = parseFloat(price.replace("$", "").replace(",", ""));
    return new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD",
      minimumFractionDigits: 2,
    }).format(numericPrice);
  };
  const shouldDisplayTable = data.some((item) => !!item.price);

  if (!shouldDisplayTable) {
    return null;
  }

  return (
    <TableContainer w="100%" overflowX="hidden" border="none">
      <Table>
        <Thead
          style={{
            backgroundColor: "#F7FAFC",
          }}
        >
          <Tr>
            <Th
              pl={{ base: "18px", md: "24px" }}
              style={{
                borderBottom: "1px solid #F7FAFC",
                textTransform: "capitalize",
                fontSize: "14px",
                color: "#2D3748",
                fontWeight: 700,
              }}
            >
              Packs
            </Th>
            <Th
              pl={{ base: "18px", md: "24px" }}
              style={{
                borderBottom: "1px solid #F7FAFC",
                textTransform: "capitalize",
                fontSize: "14px",
                color: "#2D3748",
                fontWeight: 700,
              }}
            >
              Discount (%)
            </Th>
            <Th
              pl={{ base: "18px", md: "24px" }}
              style={{
                borderBottom: "1px solid #F7FAFC",
                textTransform: "capitalize",
                fontSize: "14px",
                color: "#2D3748",
                fontWeight: 700,
              }}
            >
              For each
            </Th>
          </Tr>
        </Thead>
        <Tbody>
          {data.map((item, index) => {
            if (!item.price) {
              return null;
            }
            const isEven = index % 2 === 0;
            return (
              <Tr
                key={index}
                style={{
                  backgroundColor: isEven ? "#FFFFFF" : "#F7FAFC",
                }}
              >
                <Td
                  fontSize={"xs"}
                  pt={3}
                  pb={2.5}
                  borderBottom="1px solid #F7FAFC"
                >
                  {item.amount}
                </Td>
                <Td
                  fontSize={"xs"}
                  pt={3}
                  pb={2.5}
                  borderBottom="1px solid #F7FAFC"
                >
                  {item.discount}
                </Td>
                <Td
                  fontSize={"xs"}
                  pt={3}
                  pb={2.5}
                  borderBottom="1px solid #F7FAFC"
                >
                  {formatPrice(item.price)}
                </Td>
              </Tr>
            );
          })}
        </Tbody>
      </Table>
    </TableContainer>
  );
};

export default GridTable;
